export default {
  root: {
    marginTop: '10px',
  },
};
